export default __webpack_public_path__ + "static/media/userpp.bd0a2bd9.svg";